var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTeacherFeedbackBadge = function SvgTeacherFeedbackBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h34v34H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16,
    fill: "#DBFADF",
    fillRule: "nonzero",
    stroke: "#979797",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7.5h20v20H7z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4EA15A",
    d: "M9.5 8.333c-.92 0-1.667.746-1.667 1.667v10.833c0 .92.747 1.667 1.667 1.667H22l4.167 4.167V10c0-.92-.746-1.667-1.667-1.667zm1.667 9.167h7.5v1.667h-7.5zm0-3.333h11.666v1.666H11.167zm0-3.334h11.666V12.5H11.167z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#378142",
    d: "M9.5 8.833A1.163 1.163 0 0 0 8.333 10v10.833A1.163 1.163 0 0 0 9.5 22h12.707l3.46 3.46V10A1.163 1.163 0 0 0 24.5 8.833z"
  })))));
};
export default SvgTeacherFeedbackBadge;